import { createContext, ReactNode, useEffect, useState } from 'react'

export const MOBILE_WIDTH = 599
export const TABLET_WIDTH = 1023
export const DESKTOP_WIDTH = 1440

export type WindowSize = {
  height: number
  width: number
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const defaultWindowSize: WindowSize = {
  height: window.innerHeight,
  width: window.innerWidth,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
}
export const WindowSizeContext = createContext(defaultWindowSize)

const WindowSizeProvider = ({ children }: { children: ReactNode }) => {
  const [windowSize, setWindowSize] = useState<WindowSize>(defaultWindowSize)

  useEffect(() => {
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth <= MOBILE_WIDTH,
        isTablet:
          window.innerWidth <= TABLET_WIDTH && window.innerWidth > MOBILE_WIDTH,
        isDesktop: window.innerWidth > TABLET_WIDTH,
      })
    }
    // Add event listener
    window.addEventListener('resize', handleResize)
    // Call handler right away so state gets updated with initial window size
    handleResize()
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <WindowSizeContext.Provider value={windowSize}>
      {children}
    </WindowSizeContext.Provider>
  )
}

export default WindowSizeProvider
